export default "__VITE_ASSET__4596a65a__"